import { useQuery } from "@tanstack/react-query";
import { DropsApi } from "@devour/client";
import getConfig from "@/utils/getConfig";

/**
 * Is this Drop claiming the embedded hub slug the router maps to it?
 *
 * The Realm app embeds one url forever; what that url serves is our routing
 * decision. It used to be a constant in the bundle, so shipping the code WAS
 * the cutover — production would flip for real users the moment the branch
 * deployed. The answer is data now, which is what lets the code go out cold
 * and lets a mirror be live while production is not.
 *
 * Reads the Drop through the generated client so the field is typed by the
 * schema that produces it. `/drops/slug/:slug` takes optional auth, which
 * matters here: the embed's first visitor has no session yet, and a read that
 * needed one would answer "not live" for exactly the people the cutover is for.
 *
 * Single-instance by design — when RTTF is permanently live, this hook and the
 * router's map both come out.
 */
export function useGetDropCutover(slug?: string) {
    return useQuery({
        queryKey: ["drop-cutover", slug],
        queryFn: async () => {
            if (!slug) return null;
            return new DropsApi(getConfig()).getDropsSlugSlug({ slug });
        },
        enabled: Boolean(slug),
        /* The flip is an operator action, not a live signal — no polling. */
        staleTime: 5 * 60_000,
    });
}
